import { API } from "@/lib/api";

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function downloadExport(path, filename) {
  const token = localStorage.getItem("sg_token");
  const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error("Échec de l'export");
  triggerDownload(await res.blob(), filename);
}

export async function postDownload(path, body, filename) {
  const token = localStorage.getItem("sg_token");
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("Échec de l'export");
  triggerDownload(await res.blob(), filename);
}

export function fileDownloadUrl(fid) {
  return `${API}/files/${fid}/download?auth=${localStorage.getItem("sg_token")}`;
}
